import { useSelector } from 'react-redux';
import {
  viewLargerImageClicked,
  productDesignEditClicked,
  trackExperimentClicked,
  trackPayPalMessageClicked,
  trackNavigationClicked,
  trackPayPalPaymentAcceleratorClicked,
} from '../apis/trackingApi';
import { trackCheckoutBlockedForCustomerCart } from '../apis/newRelicTracking';
import { RootState } from '../types';
import {
  flawedCheckoutDisabledExperience,
  trackCartPageViewed,
  trackCartStepViewed,
  v1FlawedCheckoutDisabledExperience,
} from '../tracking/segmentTracker';
import { siteSelectors } from '../state/site';

export default function useTracking() {
  const cart = useSelector((state: RootState) => state.cart);
  const cartItems = useSelector((state: RootState) => state.cartItems);
  const pricing = useSelector((state: RootState) => state.pricing);
  const siteName = useSelector((state: RootState) =>
    siteSelectors.selectSiteName(state.site)
  );

  return {
    trackCartPageViewed: () => trackCartPageViewed(),
    trackCartStepViewed: () => trackCartStepViewed(cart, cartItems, pricing),
    viewLargerImageClicked: (itemId: string) =>
      viewLargerImageClicked(itemId, cart, cartItems, pricing),
    checkoutDisabledExperience: () => {
      flawedCheckoutDisabledExperience(cart, cartItems, pricing, siteName);
      // TODO: stop tracking the v1 flawed UX
      v1FlawedCheckoutDisabledExperience(cart, cartItems, pricing, siteName);
      trackCheckoutBlockedForCustomerCart(cart);
    },
    productDesignEditClicked: (itemId: string) =>
      productDesignEditClicked(itemId, cart, cartItems, pricing),
    trackExperimentClicked: (
      sourcePagePath: string,
      destinationPagePath: string,
      ctaValue: string,
      experimentName: string,
      variationName: string,
      itemId: string
    ) =>
      trackExperimentClicked({
        sourcePagePath,
        destinationPagePath,
        ctaValue,
        experimentName,
        variationName,
        itemId,
        cartItems,
      }),
    trackPayPalMessageClicked,
    trackNavigationClicked,
    trackPayPalPaymentAcceleratorClicked,
  };
}
